// Companies slice
import { StateCreator, StoreApi } from "zustand";
import { Company } from "@prisma/client";
import { AppStoreState } from "../appStore";
type SetState = StoreApi<AppStoreState>["setState"];
type GetState = StoreApi<AppStoreState>["getState"];

const createCompaniesSlice: StateCreator<
  AppStoreState,
  [],
  [],
  Pick<
    AppStoreState,
    "companies" | "setCompanies" | "selectedCompany" | "setSelectedCompany"
  >
> = (set: SetState, get: GetState, api: StoreApi<AppStoreState>) => ({
  companies: [],
  setCompanies: (companies: Company[] = []) => {
    console.log("setCompanies called with:", companies);
    set({ companies });
    setTimeout(() => {
      console.log("setCompanies state after set:", get().companies);
    }, 100);
  },
  selectedCompany: null,
  setSelectedCompany: async (company: Company | null) => {
    set({ selectedCompany: company });
    if (company?.id) {
      const transactionsRes = await fetch(
        `/api/transactions?companyId=${company.id}`
      );
      const transactionsData = await transactionsRes.json();
      set((state: AppStoreState) => {
        if (!state.user) return {};
        return {
          user: {
            ...state.user,
            selectedReport: {
              ...state.user.selectedReport,
              transactions: transactionsData.transactions || [],
            },
          },
        } as Partial<AppStoreState>;
      });
    }
  },
  loadCompanyData: async (companyId: string) => {
    const accountsRes = await fetch(
      `/api/bank-accounts?companyId=${companyId}`
    );
    const accountsData = await accountsRes.json();
    set({ bankAccounts: accountsData.bankAccounts || [] });

    const transactionsRes = await fetch(
      `/api/transactions?companyId=${companyId}`
    );
    const transactionsData = await transactionsRes.json();
    set((state: AppStoreState) => {
      if (!state.user) return {};
      return {
        user: {
          ...state.user,
          selectedReport: {
            ...state.user.selectedReport,
            transactions: transactionsData.transactions || [],
          },
        },
      } as Partial<AppStoreState>;
    });
  },
});

export default createCompaniesSlice;
